import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { loadRuntimeConfig } from './lib/runtimeConfig'
import { I18nProvider } from './i18n'
import './styles.css'

async function start() {
  await loadRuntimeConfig()
  const { App } = await import('./App')
  createRoot(document.getElementById('root')!).render(<StrictMode><I18nProvider><App /></I18nProvider></StrictMode>)
}

void start()
